import type { Shadows } from '@mui/material/styles/shadows';

import type { ColorScheme } from './types';

export const shadows = {
  dark: [
    'none',
    '0px 1px 3px rgba(0, 0, 0, 0.4), 0px 1px 2px rgba(0, 0, 0, 0.4)',
    '0px 2px 4px rgba(0, 0, 0, 0.4), 0px 3px 4px rgba(0, 0, 0, 0.4)',
    '0px 4px 6px rgba(0, 0, 0, 0.4), 0px 4px 6px rgba(0, 0, 0, 0.4)',
    '0px 6px 10px rgba(0, 0, 0, 0.4), 0px 2px 6px rgba(0, 0, 0, 0.4)',
    '0px 8px 14px rgba(0, 0, 0, 0.4), 0px 3px 8px rgba(0, 0, 0, 0.4)',
    '0px 10px 18px rgba(0, 0, 0, 0.4), 0px 4px 10px rgba(0, 0, 0, 0.4)',
    '0px 12px 22px rgba(0, 0, 0, 0.4), 0px 5px 12px rgba(0, 0, 0, 0.4)',
    '0px 14px 26px rgba(0, 0, 0, 0.4), 0px 6px 14px rgba(0, 0, 0, 0.4)',
    '0px 16px 30px rgba(0, 0, 0, 0.4), 0px 7px 16px rgba(0, 0, 0, 0.4)',
    '0px 18px 34px rgba(0, 0, 0, 0.4), 0px 8px 18px rgba(0, 0, 0, 0.4)',
    '0px 20px 38px rgba(0, 0, 0, 0.4), 0px 9px 20px rgba(0, 0, 0, 0.4)',
    '0px 22px 42px rgba(0, 0, 0, 0.4), 0px 10px 22px rgba(0, 0, 0, 0.4)',
    '0px 24px 46px rgba(0, 0, 0, 0.4), 0px 11px 24px rgba(0, 0, 0, 0.4)',
    '0px 26px 50px rgba(0, 0, 0, 0.4), 0px 12px 26px rgba(0, 0, 0, 0.4)',
    '0px 28px 54px rgba(0, 0, 0, 0.4), 0px 13px 28px rgba(0, 0, 0, 0.4)',
    '0px 30px 58px rgba(0, 0, 0, 0.4), 0px 14px 30px rgba(0, 0, 0, 0.4)',
    '0px 32px 62px rgba(0, 0, 0, 0.4), 0px 15px 32px rgba(0, 0, 0, 0.4)',
    '0px 34px 66px rgba(0, 0, 0, 0.4), 0px 16px 34px rgba(0, 0, 0, 0.4)',
    '0px 36px 70px rgba(0, 0, 0, 0.4), 0px 17px 36px rgba(0, 0, 0, 0.4)',
    '0px 38px 74px rgba(0, 0, 0, 0.4), 0px 18px 38px rgba(0, 0, 0, 0.4)',
    '0px 40px 78px rgba(0, 0, 0, 0.4), 0px 19px 40px rgba(0, 0, 0, 0.4)',
    '0px 42px 82px rgba(0, 0, 0, 0.4), 0px 20px 42px rgba(0, 0, 0, 0.4)',
    '0px 44px 86px rgba(0, 0, 0, 0.4), 0px 21px 44px rgba(0, 0, 0, 0.4)',
    '0px 46px 90px rgba(0, 0, 0, 0.4), 0px 22px 46px rgba(0, 0, 0, 0.4)',
  ],
  light: [
    'none',
    '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
    '0px 2px 4px rgba(16, 24, 40, 0.1), 0px 3px 4px rgba(16, 24, 40, 0.07)',
    '0px 4px 6px rgba(16, 24, 40, 0.1), 0px 4px 6px rgba(16, 24, 40, 0.07)',
    '0px 6px 10px rgba(16, 24, 40, 0.1), 0px 2px 6px rgba(16, 24, 40, 0.06)',
    '0px 8px 14px rgba(16, 24, 40, 0.1), 0px 3px 8px rgba(16, 24, 40, 0.07)',
    '0px 10px 18px rgba(16, 24, 40, 0.1), 0px 4px 10px rgba(16, 24, 40, 0.07)',
    '0px 12px 22px rgba(16, 24, 40, 0.1), 0px 5px 12px rgba(16, 24, 40, 0.08)',
    '0px 14px 26px rgba(16, 24, 40, 0.1), 0px 6px 14px rgba(16, 24, 40, 0.08)',
    '0px 16px 30px rgba(16, 24, 40, 0.1), 0px 7px 16px rgba(16, 24, 40, 0.08)',
    '0px 18px 34px rgba(16, 24, 40, 0.1), 0px 8px 18px rgba(16, 24, 40, 0.08)',
    '0px 20px 38px rgba(16, 24, 40, 0.1), 0px 9px 20px rgba(16, 24, 40, 0.08)',
    '0px 22px 42px rgba(16, 24, 40, 0.1), 0px 10px 22px rgba(16, 24, 40, 0.08)',
    '0px 24px 46px rgba(16, 24, 40, 0.1), 0px 11px 24px rgba(16, 24, 40, 0.08)',
    '0px 26px 50px rgba(16, 24, 40, 0.1), 0px 12px 26px rgba(16, 24, 40, 0.08)',
    '0px 28px 54px rgba(16, 24, 40, 0.1), 0px 13px 28px rgba(16, 24, 40, 0.08)',
    '0px 30px 58px rgba(16, 24, 40, 0.1), 0px 14px 30px rgba(16, 24, 40, 0.08)',
    '0px 32px 62px rgba(16, 24, 40, 0.1), 0px 15px 32px rgba(16, 24, 40, 0.08)',
    '0px 34px 66px rgba(16, 24, 40, 0.1), 0px 16px 34px rgba(16, 24, 40, 0.08)',
    '0px 36px 70px rgba(16, 24, 40, 0.1), 0px 17px 36px rgba(16, 24, 40, 0.08)',
    '0px 38px 74px rgba(16, 24, 40, 0.1), 0px 18px 38px rgba(16, 24, 40, 0.08)',
    '0px 40px 78px rgba(16, 24, 40, 0.1), 0px 19px 40px rgba(16, 24, 40, 0.08)',
    '0px 42px 82px rgba(16, 24, 40, 0.1), 0px 20px 42px rgba(16, 24, 40, 0.08)',
    '0px 44px 86px rgba(16, 24, 40, 0.1), 0px 21px 44px rgba(16, 24, 40, 0.08)',
    '0px 46px 90px rgba(16, 24, 40, 0.1), 0px 22px 46px rgba(16, 24, 40, 0.08)',
  ],
} satisfies Record<ColorScheme, Shadows>;
